module.exports = __webpack_public_path__ + "img/default.28783830.svg";